import { getApiBaseUrl, getApiKey } from 'fake-db/apiConfig'
import Mock from '../mock'
import axios from 'axios.js'
const API_URL = getApiBaseUrl()
const API_KEY = getApiKey()

const authHeaders = () => {
    const token = localStorage.getItem('accessToken')
    return token ? { headers: { Authorization: `Bearer ${token}` } } : undefined
}

const withFallbackError = (err, fallbackText) => {
    const message = err?.response?.data?.message || err?.response?.data || err?.message || fallbackText
    return [500, { message: String(message) }]
}

Mock.onGet('/api/bonus/settings/get').reply(async () => {
    try {
        const res = await axios.get(`${API_URL}/bonus/settings/get/?apiKey=${API_KEY}`, authHeaders())
        return [res?.status || 200, res?.data || {}]
    } catch (err) {
        console.error(err)
        return withFallbackError(err, 'Ошибка загрузки настроек бонусной системы')
    }
})

Mock.onPost('/api/bonus/settings/save').reply(async (config) => {
    try {
        const data = JSON.parse(config?.data || '{}')
        const res = await axios.post(`${API_URL}/bonus/settings/save/?apiKey=${API_KEY}`, data, authHeaders())
        return [res?.status || 200, res?.data || {}]
    } catch (err) {
        console.error(err)
        return withFallbackError(err, 'Ошибка сохранения настроек бонусной системы')
    }
})

Mock.onPost('/api/bonus/operations/get').reply(async (config) => {
    try {
        const data = JSON.parse(config?.data || '{}')
        const res = await axios.post(`${API_URL}/bonus/operations/get/?apiKey=${API_KEY}`, data, authHeaders())
        return [res?.status || 200, res?.data || {}]
    } catch (err) {
        console.error(err)
        return withFallbackError(err, 'Ошибка загрузки операций бонусной системы')
    }
})

Mock.onPost('/api/bonus/operation/manual-adjust').reply(async (config) => {
    try {
        const data = JSON.parse(config?.data || '{}')
        const res = await axios.post(`${API_URL}/bonus/operation/manual-adjust/?apiKey=${API_KEY}`, data, authHeaders())
        return [res?.status || 200, res?.data || {}]
    } catch (err) {
        console.error(err)
        return withFallbackError(err, 'Ошибка ручной корректировки бонусов')
    }
})
